<template>
  <div ref="collapseRoot" class="sand-tableCollapse" v-if="collapseData.length !== 0 && columnData.length !== 0">
    <div class="sand-tableCollapse__tableHeader">
      <div
        class="sand-tableCollapse__tableHeader--item"
        v-for="item in columnData"
        :key="item.prop"
        :style="`
          width: ${item.width ? getWidth(item.width) : '0px'};
          flex-grow: ${item.width ? '0' : item.col ? item.col : '1'};
          text-align: ${item.headAlign ? item.headAlign : item.align ? item.align : 'left'};
        `"
      >
        <span class="sand-tableCollapse__tableHeader--text">{{ item.label }}</span>
      </div>
    </div>
    <el-collapse v-model="collapseVal" accordion>
      <el-collapse-item
        :class="{ 'sand-tableCollapse__stripe': tableProps.stripe }"
        v-for="(collapse, index) in collapseData"
        :key="index"
        :name="index"
      >
        <template #title>
          <div class="sand-tableCollapse__header">
            <div
              class="sand-tableCollapse__header--item"
              v-for="item in columnData"
              :key="item.prop"
              :style="`
                width: ${item.width ? getWidth(item.width) : '0px'};
                flex-grow: ${item.width ? '0' : item.col ? item.col : '1'};
                text-align: ${item.align ? item.align : 'left'};
              `"
            >
              <!-- <div @click.stop="toTi(collapse)" v-if="item.type === 'ti'">
                <el-tooltip :effect="$isDark() ? 'dark' : 'light'" :content="$t('ti')" placement="top">
                  <svg-icon name="sousuoti"></svg-icon>
                </el-tooltip>
              </div> -->
              <div v-if="item.type === 'detect'" @click.stop="redect(collapse)">
                <el-tooltip :effect="$isDark() ? 'dark' : 'light'" :content="$t('dialog.detect.label')" placement="top">
                  <svg-icon name="tijiaojiance"></svg-icon>
                </el-tooltip>
              </div>
              <div
                v-if="item.type === 'download'"
                :class="[
                  'sand-tableCollapse__header--download',
                  { disable: !collapse.download_url || !(gid >= 2 || (scoreInfo && scoreInfo[computed_type] > 0)) }
                ]"
                @click.stop="confirm(collapse)"
              >
                <el-tooltip :effect="$isDark() ? 'dark' : 'light'" :content="$t('download.action')" placement="top">
                  <svg-icon name="xiazai1"></svg-icon>
                </el-tooltip>
              </div>
              <span
                v-else
                class="sand-tableCollapse__header--text"
                v-html="collapse[item.prop]"
              ></span>
            </div>
          </div>
        </template>
        <slot :childrenData="collapse.childrenData"></slot>
      </el-collapse-item>
    </el-collapse>
    <UpgradeDialog
      v-model:show="isShowUpgrade"
      :type="upgradeType"
      :showPoint="isLogin"
      :showNormal="!isLogin"
    />
    <el-dialog
      v-model="isShowWarning"
      :title="$t('report.overview.operate.download.confirm')"
      width="30%"
      custom-class="comfirm-dialog"
    >
      <div class="deleteContent">
        <svg-icon name="info"></svg-icon>
        <span style="line-height: 21px; flex: 1">{{$t('report.overview.operate.download.warm')}}</span>
      </div>
      <div style="padding-left: 28px;line-height: 21px;">{{$t('report.overview.operate.download.warm1')}}<span style="font-weight: 700">360ata</span></div>
      <template #footer>
        <span class="dialog-footer" style="position: relative;top: 4px;">
          <el-button @click="isShowWarning = false">{{$t('dialog.cancel')}}</el-button>
          <el-button type="primary" @click="continueDownload"
            >{{$t('action.confirm')}}</el-button
          >
        </span>
        <el-checkbox @change="changeNolonger" style="float: left;" v-model="noLongerWarn" label="不再提示" />
      </template>
    </el-dialog>
  </div>
  <sand-no-data :isFullscreen="!isPdfPage" v-else></sand-no-data>
</template>
<script>
import sandNoData from './sandNoData'
import { downloadSample } from 'services/report'
import { download } from 'utils/tools'
import { mapGetters, mapState } from 'vuex'
import UpgradeDialog from '@/components/common/upgradeDialog'
import { t } from 'app/i18n'

export default {
  components: {
    UpgradeDialog,
    sandNoData
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        // collapseData: [{
        //   date: '微软软件',
        //   ddd: 'dddddd',
        //   childrenData: {}
        // }, {
        //   date: '微软软件',
        //   ddd: 'dddddd',
        //   childrenData: {}
        // }],
        // columnData: [{
        //   prop: 'date',
        //   label: 'date',
        //   width: '100px',
        //   col: undefined,
        //   align: 'center'
        // }, {
        //   prop: 'ddd',
        //   label: 'ddd',
        //   width: undefined,
        //   col: undefined,
        //   align: 'center'
        // }, {
        //   prop: 'aaa',
        //   label: 'aaa',
        //   width: undefined,
        //   col: undefined,
        //   align: 'center',
        //   type: 'download'
        // }],
        // tableProps: {
        //   stripe: true
        // }
      })
    },
    isPdfPage: {
      type: Boolean,
      default: false
    },
    upgradeType: {
      type: String,
      default: 'C2'
    }
  },
  data() {
    return {
      collapseVal: [],
      isShowUpgrade: false,
      isShowWarning: false,
      noLongerWarn: localStorage.getItem('downloadWarning') === '1',
      collapse: {},
      scrollTimer: null
    }
  },
  computed: {
    ...mapGetters(['gid', 'isLogin']),
    ...mapState({
      scoreInfo: (state) => state.user.scoreInfo,
      tiToken: (state) => state.user.tiToken
    }),
    reportState() {
      return this.$store.getters.getReportState
    },
    collapseData() {
      if (this.data) {
        return this.data.collapseData || []
      }
      return []
    },
    columnData() {
      if (this.data) {
        return this.data.columnData || []
      }
      return []
    },
    tableProps() {
      if (this.data) {
        return this.data.tableProps || {}
      }
      return {}
    },
    computed_type() {
      // return this.upgradeType === 'C4' ? 'memdumps_down_last' : 'release_down_last'
      return 'download_last'
    }
  },
  watch: {
    reportState() {
      this.setReportStatic()
    },
    data: {
      deep: true,
      immediate: true,
      handler() {
        // 外部可通过 tableProps.collapseVal 指定默认展开项，例如按 md5 定位到某一条数据。
        this.applyCollapseValFromProps()
      }
    }
  },
  mounted() {
    this.setReportStatic()
  },
  methods: {
    applyCollapseValFromProps() {
      const preset = this.tableProps && this.tableProps.collapseVal
      if (!preset || (Array.isArray(preset) && preset.length === 0)) return false
      // el-collapse 在 accordion 模式下使用单值；非 accordion 模式下才使用数组。
      if (Array.isArray(preset)) {
        this.collapseVal = preset.length === 1 ? preset[0] : preset
      } else {
        this.collapseVal = preset
      }
      this.$nextTick(() => {
        this.scheduleScrollToCollapseItem(preset)
      })
      return true
    },
    scheduleScrollToCollapseItem(preset) {
      const targetIndex = Array.isArray(preset) ? preset[0] : preset
      if (typeof targetIndex !== 'number' || targetIndex < 0) return
      const root = this.$refs.collapseRoot
      if (!root) return
      const items = root.querySelectorAll('.el-collapse-item')
      const target = items[targetIndex]
      if (!target) return

      const wrap = target.querySelector('.el-collapse-item__wrap')
      const fallbackDelay = 350
      const runScroll = () => {
        if (this.scrollTimer) {
          clearTimeout(this.scrollTimer)
          this.scrollTimer = null
        }
        // nextTick 只能保证 DOM 已更新，不能保证折叠展开动画已结束；
        // 再等一帧后滚动，可以拿到更稳定的位置。
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.scrollToCollapseItem(target)
          })
        })
      }

      if (wrap) {
        // 优先等折叠内容高度动画结束后再滚动，避免定位偏差。
        wrap.addEventListener('transitionend', runScroll, { once: true })
      }

      // 兜底处理：某些场景下 transitionend 不触发时，仍然执行一次滚动。
      this.scrollTimer = setTimeout(runScroll, fallbackDelay)
    },
    scrollToCollapseItem(target) {
      if (!target) return

      const root = this.$refs.collapseRoot
      const container = root?.closest('.contentWrapper') || document.querySelector('.contentWrapper')
      if (!container || typeof container.scrollTo !== 'function') {
        if (typeof target.scrollIntoView === 'function') {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
        return
      }

      // 报告页实际滚动的是 .contentWrapper，因此这里手动计算容器内偏移量，
      // 比直接使用 scrollIntoView 更稳定。
      const containerRect = container.getBoundingClientRect()
      const targetRect = target.getBoundingClientRect()
      const offset = 16
      const top = container.scrollTop + (targetRect.top - containerRect.top) - offset

      container.scrollTo({
        top: Math.max(top, 0),
        behavior: 'smooth'
      })
    },
    redect(collapse) {
      this.$emit('detect', collapse)
    },
    // toTi(data) {
    //   window.open(`https://ti.360.net/#/detailpage/searchresult?query=${data.md5}&rand=${Math.random()}&sign=${this.tiToken}&from=ata`)
    //   // window.open(`https://10.146.250.137/#/detailpage/searchresult?query=${data.md5}&rand=${Math.random()}&sign=${this.tiToken}&from=ata`)
    // },
    setReportStatic() {
      if (this.reportState) {
        this.open()
      }
    },
    open() {
      this.collapseVal = []
      this.collapseData.forEach((_, index) => {
        this.collapseVal.push(index)
      })
    },
    close() {
      this.collapseVal = []
    },
    confirm(collapse) {
      if (this.noLongerWarn) {
        this.downloadsample(collapse)
      } else {
        this.collapse = collapse
        this.isShowWarning = true
      }
    },
    continueDownload() {
      this.downloadsample(this.collapse)
      this.isShowWarning = false
    },
    async downloadsample(file) {
      if (!file.download_url) return
      if (this.gid >= 2 || (this.scoreInfo && this.scoreInfo[this.computed_type] > 0)) {
        await downloadSample(file.download_url.replace('/api/v1', ''))
          .then((res) => {
            const filename = res.headers['content-disposition'].match(/filename=(.+)/)[1]
            download({
              content: res.data,
              type: 'application/octet-stream;',
              filename
            })
            this.$store.dispatch('user/getScoreInfo')
          })
          .catch((err) => {
            if (err.message !== 'Request failed with status code 429') {
              this.$store.commit('app/showMessage', {
                type: 'error',
                message: t('download.not_found'),
                duration: 1000
              })
            } else {
              if (this.gid === 1) {
                this.isShowUpgrade = true
              }
            }
          })
      } else {
        this.isShowUpgrade = true
      }
    },
    getWidth(data) {
      if (data.indexOf('px') > 0) {
        return data
      }
      return data + 'px'
    }
  },
  beforeUnmount() {
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer)
      this.scrollTimer = null
    }
  }
}
</script>
<style lang="scss">
.deleteContent {
  display: flex;
  svg {
    margin-right: 8px;
    font-size: 20px;
    color:#fa8c16;
  }
}
.comfirm-dialog .el-checkbox__label {
  color: var(--color-text-2) !important;
}
</style>
<style lang="scss" scoped>
.sand-tableCollapse {
  /* 折叠面板项的每一项 */
  & :deep(.el-collapse-item) {
    // border 1px solid;
    // bd_color(color-collapse-border)
    border-bottom: 0;

    &.sand-tableCollapse__stripe:nth-child(even) .el-collapse-item__header {
      // bg_color(color-table-collapse-even);
    }
  }

  /* 边框都不需要 */
  & :deep(.el-collapse), & :deep(.el-collapse-item__header), & :deep(.el-collapse-item__wrap) {
    border: 0;
    background: transparent;
  }

  & :deep(.el-collapse-item__arrow) {
    height: 13px;
    margin-right: 20px;
    color: var(--color-text-3);
    &.is-active {
      color: var(--color-text-1);
    }
  }

  & :deep(.el-icon-arrow-right:before) {
    content: url('./../../assets/img/svg/triangle.svg');
  }

  /* 折叠面板项 */
  & :deep(.el-collapse-item__header) {
    height: 47px;
    font-weight: normal;
    // bg_color(color-table-collapse-odd);
    color: var(--color-text-2);
    &.is-active {
      .sand-tableCollapse__header .sand-tableCollapse__header--item {
        .sand-tableCollapse__header--text, svg {
          color: var(--color-text-1);
        }
      }
    }

    &:hover {
      // bg_color(color-table-collapse-hover);

      & .el-icon-arrow-right:before {
        filter: brightness(--svg-filter2);
      }
    }
  }

  /* 折叠面板项 */
  & .sand-tableCollapse__header {
    width: 100%;
    display: flex;
    padding: 0 15px;
    height: 40px;

    &--item {
      flex-shrink: 0;
      // word-break:break-all;
      // word-wrap:break-word;
      align-items: center;
      display: flex;
      // padding-right: 15px;
    }

    &--text {
      width: 100%;
      line-height: 20px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--color-text-2);
    }
    svg {
      font-size: 16px;
      color: var(--color-text-2);
      &:hover {
        color: var(--color-text-1);
      }
    }

    &--download {
      height: 22px;
      // width: 92px;
      background: transparent;
      // border 1px solid;
      // bd_color(color-sand-border)
      // border-radius: 4px;
      line-height: 22px;
      text-align: center;
      font-size: 14px;
      color: var(--color-text-2);
      font-weight: bold;
      svg {
        font-size: 16px;
        &:focus {
          outline: none;
        }
      }

      &.disable {
        // filter: grayscale(1);
        color: var(--color-text-3);
        cursor: not-allowed;
      }
    }
  }

  /* 表头 */
  & .sand-tableCollapse__tableHeader {
    display: flex;
    height: 48px;
    line-height: 48px;
    color: var(--color-text-2);
    background-color: var(--color-bg-3);
    padding: 0 67px 0 15px;
    // border-bottom: 1px solid var(--color-border-2);
    &--item {
      flex-shrink: 0;
      word-break: break-all;
      word-wrap: break-word;
      display: flex;
      align-items: center;
    }

    &--text {
      width: 100%;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
